import React, { useState, useMemo } from 'react';
// Korrektur: Füge .js hinzu, um die Modulauflösung zu erzwingen
import { markNotificationAsRead } from '../services/firestoreService.js';

const NotificationBell = ({ userNotifications, userId, setNotification }) => {
    const [isOpen, setIsOpen] = useState(false);

    // Filtert und zählt die ungelesenen Benachrichtigungen
    const unreadNotifications = useMemo(() => {
        // Sicherstellen, dass userNotifications ein Array ist
        // Da getUserNotifications nur ungelesene lädt, ist dies einfach die Länge des Arrays
        return (userNotifications || []).filter(n => !n.isRead);
    }, [userNotifications]);

    const count = unreadNotifications.length;

    const handleReadClick = async (notification) => {
        if (!userId) return;
        try {
            // Markiert EINE einzelne Notification als gelesen (für den Button im Dropdown)
            await markNotificationAsRead(userId, notification.id);
            setNotification({ message: `Benachrichtigung für Protokoll \"${notification.meetingTitle}\" als gelesen markiert.`, type: 'info' });
        } catch (error) {
            console.error("Error marking notification as read:", error);
            setNotification({ message: 'Fehler beim Markieren als gelesen.', type: 'error' });
        }
    };

    const toggleOpen = () => setIsOpen(prev => !prev);

    return (
        <div className="relative">
            {/* Glocken-Button */}
            <button 
                onClick={toggleOpen} 
                className="relative p-2 rounded-full text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition duration-150"
                title={`Sie haben ${count} ungelesene Benachrichtigungen.`}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>
                {/* Badge mit Zähler */}
                {count > 0 && (
                    <span 
                        className="absolute top-0 right-0 transform translate-x-1/4 -translate-y-1/4 h-5 w-5 rounded-full ring-2 ring-white dark:ring-gray-900 bg-red-600 flex items-center justify-center text-white text-xs font-bold p-1 shadow-md"
                        style={{ minWidth: '20px', minHeight: '20px' }} // Stellt sicher, dass das Badge groß genug für die Zahl ist
                    >
                        {count > 9 ? '9+' : count}
                    </span>
                )}
            </button>

            {/* Dropdown-Panel */}
            {isOpen && (
                <div 
                    className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-2xl z-50 border dark:border-gray-700 overflow-hidden"
                    style={{ maxHeight: '400px', overflowY: 'auto' }}
                >
                    <div className="p-4 border-b dark:border-gray-700">
                        <h3 className="font-bold text-lg">Benachrichtigungen ({count} ungelesen)</h3>
                    </div>

                    {unreadNotifications.length === 0 ? (
                        <p className="p-4 text-gray-500 dark:text-gray-400 text-sm">Keine ungelesenen Benachrichtigungen.</p>
                    ) : (
                        unreadNotifications.map(n => (
                            <div key={n.id} className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150">
                                <div className="p-3">
                                    <p className="font-semibold text-sm truncate">{n.meetingTitle}</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                        {n.isExternal ? 'Externes Protokoll' : 'Neues Protokoll'} zur Kollaboration bereit.
                                    </p>
                                    <button
                                        onClick={() => handleReadClick(n)}
                                        className="mt-2 text-xs font-medium text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                                    >
                                        Als gelesen markieren
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationBell;
